export const Products = () => (
  <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 0C7.9 0 7 0.9 7 2C7 3.11 7.9 4 9 4C10.11 4 11 3.11 11 2C11 0.9 10.11 0 9 0ZM0 5V7H6V13L0.93 18.07L2.34 19.5L9.06 12.77L13 15.13V19H15V14.57C15 14.21 14.82 13.89 14.5 13.71L11 11.6V7H17V5H0Z"
      fill="black"
      fillOpacity="0.56"
    />
  </svg>
);
